import { IMatrix4, IVector3 } from '../../../../api.js';
import { get_euler_angles_from_rotation_matrix } from '../../../../Math.js';
import { RotationTorus } from './RotationTorus.js';
export class RotateGizmo {
    constructor(viewer, transform_handling, use_global_transorm) {
        this.transform_handling = transform_handling;
        this.use_global_transorm = use_global_transorm;
        this._viewer = viewer;
        this._ui_mesh = this._viewer.create_ui_mesh();
        this.gizmo = this._ui_mesh.create_gizmo();
        this.toruses = {
            x: this.create_rotation_torus('x'),
            y: this.create_rotation_torus('y'),
            z: this.create_rotation_torus('z')
        };
    }
    create_rotation_torus(axis) {
        const axes = new Set(['x', 'y', 'z']);
        const torus = new RotationTorus(this._viewer, this.transform_handling, this.use_global_transorm, axis);
        torus.gizmo.set_parent(this.gizmo);
        axes.delete(axis);
        torus.gizmo.drag_begin_observable.add(() => {
            axes.forEach(a => this.toruses[a].dispose());
        });
        torus.gizmo.drag_end_observable.add(() => {
            axes.forEach(a => { this.toruses[a] = this.create_rotation_torus(a); });
        });
        return torus;
    }
    update_gizmo_rotation() {
        if (this.use_global_transorm || !this.transform_handling.get_world_transform) {
            this.gizmo.rotation = IVector3.Zero();
        }
        else {
            const world_rotation = IMatrix4.extractRotationMatrix(this.transform_handling.get_world_transform());
            this.gizmo.rotation = get_euler_angles_from_rotation_matrix(world_rotation);
        }
    }
    dispose() {
        this.toruses.x.dispose();
        this.toruses.y.dispose();
        this.toruses.z.dispose();
        this.gizmo.dispose();
    }
}
//# sourceMappingURL=RotateGizmo.js.map